import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const CloseIcon = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={ref}
        >
          <path
            d="M1 17L9 9M17 1L9 9M17 17L9 9M1 1L9 9"
            stroke="currentColor"
            strokeLinecap="square"
          />
        </svg>
      </Icon>
    );
  },
);

CloseIcon.displayName = "CloseIcon";
